import { useTranslation } from 'next-i18next';
import Proportion from "./proportion";
import Link from "next/link";

/**
 *
 */
type IngredientType = {
    id : string
    name : string
    translation : string
    trafficLight : string
    proportion : number
    count : number
};

/**
 *
 */
type Data = {
    ingredientTypes : IngredientType[]
    filled : boolean
    baseURL : string
};

/**
 *
 * @param ingredientTypes
 * @param filled
 * @param baseURL
 * @constructor
 */
export default function IngredientTypeProportions (
    {
        ingredientTypes,
        filled,
        baseURL
    } : Data
) {
    // init
    const { t } = useTranslation();
    let style = 'mb-3 text-center';
    style += filled ? ' col-12 col-sm-5 col-md-3 col-lg-4 col-xl-3' : ' col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3';
    const linkStyle = (filled ? 'mt-1 ' : '') + ' col-11 btn btn-outline-primary btn-sm';

    // render
    return (
        <>
            <div className={'mb-3 d-flex flex-row flex-wrap'}>
                {ingredientTypes.map((ingredientType) => (
                    <div key={'ingredient-type-proportion-' + ingredientType.id} className={style}>
                        <Proportion type={ingredientType.trafficLight} proportion={ingredientType.proportion} value={ingredientType.translation} filled={filled} />
                        <Link
                            href={baseURL + '&it_' + encodeURIComponent(ingredientType.id) + '=1'}
                            className={linkStyle}
                            role={'button'}
                            dangerouslySetInnerHTML={{__html: t('products.' + ingredientType.name, {ns: 'glossary'})}}
                        />
                    </div>
                ))}
            </div>
        </>
    );
}